import { ArenaGameState, BidRecord } from '../../state/ArenaTypes';
import { GameTableConfig } from '../../engine/tableConfig/types';
import { ContractFormatContext } from '../common/IGameRules';
import { IScorePresenter } from '../common/IScorePresenter';
import { IContractFormatterStrategy } from '../common/IContractFormatterStrategy';

/**
 * Presentation-only contract formatter for Spades partnership contracts.
 */
export class SpadesContractFormatter implements IContractFormatterStrategy {
  public formatContractName(
    _rawBid?: number | null,
    _direction?: string | null,
    _suit?: string | null,
    _isNoTrump?: boolean,
    fallbackContract?: string,
    _config?: GameTableConfig
  ): string {
    return fallbackContract || 'Partnership Contract';
  }

  public formatContractOutcome(
    gameState: ArenaGameState,
    _context?: ContractFormatContext,
    _config?: GameTableConfig,
    _scorePresenter?: IScorePresenter
  ): string {
    return `T1: ${gameState.team1Books ?? 0} | T2: ${gameState.team2Books ?? 0}`;
  }

  public getContractSummaryText(gameState: ArenaGameState, _config?: GameTableConfig): string | null {
    const raw = (gameState as any).contractSummary;
    if (raw) return String(raw);

    const bts = gameState.booksToSet;
    const t1Target = bts?.team1?.target ?? bts?.team1?.bid;
    const t2Target = bts?.team2?.target ?? bts?.team2?.bid;
    if (t1Target !== undefined && t2Target !== undefined) {
      return `T1: ${t1Target} | T2: ${t2Target}`;
    }

    return null;
  }

  public getHighestBidRecord(bids?: BidRecord[]): BidRecord | null {
    if (!bids || bids.length === 0) return null;
    let highest: BidRecord | null = null;
    for (const b of bids) {
      if (b.bid > 0) {
        if (!highest || b.bid > highest.bid) {
          highest = b;
        }
      }
    }
    return highest;
  }
}
